import { useCallback, useRef } from "react";

export default function useInfiniteScroll({ isLoading, hasMore, onLoadMore }) {
	const observerRef = useRef(null);

	return useCallback(
		(node) => {
			if (isLoading) {
				return;
			}

			if (observerRef.current) {
				observerRef.current.disconnect();
			}

			observerRef.current = new IntersectionObserver((entries) => {
				if (!entries[0]?.isIntersecting) {
					return;
				}

				if (hasMore) {
					onLoadMore();
				}
			});

			if (node) {
				observerRef.current.observe(node);
			}
		},
		[isLoading, hasMore, onLoadMore]
	);
}
